import { httpClient } from '../http/httpClient'

export async function getConfigs() {
  const { data } = await httpClient.get<Config[]>('/config')

  return data
}
